import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { RecommendedServiceUp } from 'src/app/api/recommendedService/recommendedServiceUp';
import { RecommendedServiceApiService } from 'src/app/api/recommendedService/recommendedServiceApiService';

@Component({
    selector: 'service-recommendation-details',
    templateUrl: './service-recommendation-details.component.html',
    styleUrls: ['./service-recommendation-details.component.css'],
    standalone: false
})
export class ServiceRecommendationDetailsComponent {
  serviceRecommendation: RecommendedServiceUp | null = null;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private recommendedServiceApiService: RecommendedServiceApiService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null)
      return;

    this.loading = true;
    this.recommendedServiceApiService.getRecommendedService(id)
      .subscribe(x => {
        this.serviceRecommendation = x;
        this.loading = false;
      });
  }

  back(): void {
    this.location.back()
  }
}
